import {format} from 'utils'
import request from 'company-management/utils/request'
import api from './api'

export async function query() {
    return request(api.list.url)
}

export async function queryTree() {
    return request(api.tree.url)
}

export async function create(payload) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload?.body,
    })
}

export async function modify(payload) {
    return request(format(api.update.url, {id: payload.id}), {
        method: api.update.type,
        body: payload?.body,
    })
}

export async function remove(payload) {
    return request(format(api.remove.url, {id: payload.id}), {
        method: api.remove.type,
    })
}
